import moment from 'moment';

import { customReports } from '../../../routes/reports/locale';

import {
  CONFIRM_REPORT_SCHEDULER_DATE_RANGE,
  ON_REPORT_SCHEDULER_TIME_CHANGE,
  ON_REPORT_SCHEDULER_DATE_RANGE_CHANGE,
  ON_REPORT_SCHEDULER_DATE_RANGE_FOCUS_CHANGE,
  ON_REPORT_SCHEDULER_DATE_RANGE_CHOSEN,
  ON_REPORT_SCHEDULER_FREQUENCY_CHANGE,
  ON_REPORT_SCHEDULER_TOGGLE,
  ON_REPORT_SCHEDULER_HOUR_CHANGE,
  ON_REPORT_SCHEDULER_DAY_CHANGE,
  UPDATE_STATE_WITH_FETCHED_REPORT
} from '../actions';

const initialState = {
  tempDateRange: {
    startDate: moment.utc(),
    endDate: moment.utc().add(1, 'week'),
  },
  dateRange: {
    startDate: moment.utc(),
    endDate: moment.utc().add(1, 'week'),
  },
  focusedInput: 'startDate',
  frequency: {
    selected: { message: customReports.schedulerFrequencyDaily, value: 'DAILY', id: 'daily' },
    options: [
      { message: customReports.schedulerFrequencyDaily, value: 'DAILY', id: 'daily' },
      { message: customReports.schedulerFrequencyWeekly, value: 'WEEKLY', id: 'weekly' },
    ]
  },
  enabled: false,
  time: {
    hour: { message: '0:00 AM', value: 0, id: '0am' },
    day: { message: customReports.schedulerSunday, value: 'SUNDAY', id: 'sun' },
    hourOptions: [
      { message: '0:00 AM', value: 0, id: '0am' },
      { message: '1:00 AM', value: 1, id: '1am' },
      { message: '2:00 AM', value: 2, id: '2am' },
      { message: '3:00 AM', value: 3, id: '3am' },
      { message: '4:00 AM', value: 4, id: '4am' },
      { message: '5:00 AM', value: 5, id: '5am' },
      { message: '6:00 AM', value: 6, id: '6am' },
      { message: '7:00 AM', value: 7, id: '7am' },
      { message: '8:00 AM', value: 8, id: '8am' },
      { message: '9:00 AM', value: 9, id: '9am' },
      { message: '10:00 AM', value: 10, id: '10am' },
      { message: '11:00 AM', value: 11, id: '11am' },
      { message: '12:00 PM', value: 12, id: '12pm' },
      { message: '1:00 PM', value: 13, id: '1pm' },
      { message: '2:00 PM', value: 14, id: '2pm' },
      { message: '3:00 PM', value: 15, id: '3pm' },
      { message: '4:00 PM', value: 16, id: '4pm' },
      { message: '5:00 PM', value: 17, id: '5pm' },
      { message: '6:00 PM', value: 18, id: '6pm' },
      { message: '7:00 PM', value: 19, id: '7pm' },
      { message: '8:00 PM', value: 20, id: '8pm' },
      { message: '9:00 PM', value: 21, id: '9pm' },
      { message: '10:00 PM', value: 22, id: '10pm' },
      { message: '11:00 PM', value: 23, id: '11pm' }
    ],
    dayOptions: [
      { message: customReports.schedulerSunday, value: 'SUNDAY', id: 'sun' },
      { message: customReports.schedulerMonday, value: 'MONDAY', id: 'mon' },
      { message: customReports.schedulerTuesday, value: 'TUESDAY', id: 'tue' },
      { message: customReports.schedulerWednesday, value: 'WEDNESDAY', id: 'wed' },
      { message: customReports.schedulerThursday, value: 'THURSDAY', id: 'thu' },
      { message: customReports.schedulerFriday, value: 'FRIDAY', id: 'fri' },
      { message: customReports.schedulerSaturday, value: 'SATURDAY', id: 'sat' },
    ]
  }
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {
    default: return state;
    case ON_REPORT_SCHEDULER_TIME_CHANGE: {
      return {
        ...state,
        time: {
          ...state.time,
          selectedTime: action.payload
        }
      };
    }
    case ON_REPORT_SCHEDULER_DATE_RANGE_CHANGE: {
      return Object.assign({}, state, {
        dateRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate || action.payload.startDate
        }
      });
    }
    case ON_REPORT_SCHEDULER_DATE_RANGE_FOCUS_CHANGE: {
      return Object.assign({}, state, {
        focusedInput: action.payload
      });
    }

    case CONFIRM_REPORT_SCHEDULER_DATE_RANGE:
      return Object.assign({}, state, {
        dateRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      });

    case ON_REPORT_SCHEDULER_DATE_RANGE_CHOSEN:
      return Object.assign({}, state, {
        tempDateRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate || action.payload.startDate
        }
      });

    case ON_REPORT_SCHEDULER_FREQUENCY_CHANGE:
      return Object.assign({}, state, {
        frequency: {
          ...state.frequency,
          selected: action.payload
        }
      });

    case ON_REPORT_SCHEDULER_TOGGLE:
      return Object.assign({}, state, {
        enabled: !state.enabled
      });

    case ON_REPORT_SCHEDULER_HOUR_CHANGE:
      return Object.assign({}, state, {
        time: {
          ...state.time,
          hour: action.payload
        }
      });

    case ON_REPORT_SCHEDULER_DAY_CHANGE:
      return Object.assign({}, state, {
        time: {
          ...state.time,
          day: action.payload
        }
      });
    case UPDATE_STATE_WITH_FETCHED_REPORT: {
      const report = action.payload.fetchedReport;
      const isDaily = report.days.length === 7;

      return Object.assign({}, state, {
        time: {
          ...state.time,
          hour: initialState.time.hourOptions.find(opt => opt.value === report.hour),
          day: isDaily ? initialState.time.dayOptions[0] : initialState.time.dayOptions.find(opt => opt.value === report.days[0])
        },
        tempDateRange: {
          startDate: moment(report.from),
          endDate: moment(report.to)
        },
        enabled: report.enabled,
        frequency: {
          ...state.frequency,
          selected: isDaily ? initialState.frequency.options[0] : initialState.frequency.options[1]
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/reports/reducers/custom-scheduler.js